import theme from '../theme'

export interface BgByMeasureTypeItem {
	[key: string]: string
}

export const BG_BY_MEASURE_TYPE: Array<BgByMeasureTypeItem> = [
	{
		id: 'hypo',
		label: 'Hypo',
		light: theme.palette.burntSienna.light,
		main: theme.palette.burntSienna.main,
	},

	{
		id: 'low',
		label: 'Low',
		light: theme.palette.gold.light,
		main: theme.palette.gold.main,
	},

	{
		id: 'in_range',
		label: 'In range',
		light: theme.palette.sushi.light,
		main: theme.palette.sushi.main,
	},

	{
		id: 'high',
		label: 'High',
		light: theme.palette.steelBlue.light,
		main: theme.palette.steelBlue.main,
	},

	{
		id: 'hyper',
		label: 'Hyper',
		light: theme.palette.trueV.light,
		main: theme.palette.trueV.main,
	},
]
